"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPlus', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M12.9399 6.93993H9.06007V3.06007C9.06007 2.47461 8.58546 2 8 2C7.41454 2 6.93993 2.47461 6.93993 3.06007V6.93993H3.06007C2.47461 6.93993 2 7.41454 2 8C2 8.58546 2.47461 9.06007 3.06007 9.06007H6.93993V12.9399C6.93993 13.5254 7.41454 14 8 14C8.58546 14 9.06007 13.5254 9.06007 12.9399V9.06007H12.9399C13.5254 9.06007 14 8.58546 14 8C14 7.41454 13.5254 6.93993 12.9399 6.93993Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M16 9H11V4C11 3.447 10.553 3 10 3C9.447 3 9 3.447 9 4V9H4C3.447 9 3 9.447 3 10C3 10.553 3.447 11 4 11H9V16C9 16.553 9.447 17 10 17C10.553 17 11 16.553 11 16V11H16C16.553 11 17 10.553 17 10C17 9.447 16.553 9 16 9'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M19.2 10.8H13.2V4.8C13.2 4.1364 12.6636 3.6 12 3.6C11.3364 3.6 10.8 4.1364 10.8 4.8V10.8H4.79998C4.13638 10.8 3.59998 11.3364 3.59998 12C3.59998 12.6636 4.13638 13.2 4.79998 13.2H10.8V19.2C10.8 19.8636 11.3364 20.4 12 20.4C12.6636 20.4 13.2 19.8636 13.2 19.2V13.2H19.2C19.8636 13.2 20.4 12.6636 20.4 12C20.4 11.3364 19.8636 10.8 19.2 10.8'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M25.6 14.4H17.6V6.4C17.6 5.5152 16.8848 4.8 16 4.8C15.1152 4.8 14.4 5.5152 14.4 6.4V14.4H6.39999C5.51519 14.4 4.79999 15.1152 4.79999 16C4.79999 16.8848 5.51519 17.6 6.39999 17.6H14.4V25.6C14.4 26.4848 15.1152 27.2 16 27.2C16.8848 27.2 17.6 26.4848 17.6 25.6V17.6H25.6C26.4848 17.6 27.2 16.8848 27.2 16C27.2 15.1152 26.4848 14.4 25.6 14.4'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;